/* eslint-disable simple-import-sort/imports */

import {Button, IconButton} from '@mui/material';
import './CompteExpert.scss';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { DatePickerComponent, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import useRole from '../../../hooks/useRole';
import {formatDateYYYY } from '../../../Utils/dateFormatter';
//import useDateRangeValidator from '../../../hooks/useDateRangeValidator';
import { buttonStylesGreen,buttonStyles } from '../../../Components/docsAdministrative/JsObjectStyles';
import { useTranslation } from 'react-i18next';
import { authorizedTypes } from './DonneeCvPartage';
//import moment from 'moment';
//import { TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';

function EditerCertificats({index, certificats,setCertificats,setCheckUpdateValue, typeTraitement}) {
    EditerCertificats.propTypes = {
        typeTraitement:PropTypes.any,
        index:PropTypes.any,
        certificats:PropTypes.any,
        setCertificats:PropTypes.func,
        chekDateFin:PropTypes.any,
        setChekDateFin:PropTypes.any,
        setCheckUpdateValue:PropTypes.func,
    };

    const [certificat,setCertificat]=useState();
    const [titre,setTitre]=useState();
    //const [dateDebut,setDateDebut]=useState(null);
    const [date,setDate]=useState(null);
    const { i18n } = useTranslation();
    //const [dateFin,setDateFin]=useState(null);
    const role=useRole();
    //const [isValidRangeDateCertif, messageRangeDateCertif] = useDateRangeValidator(dateDebut, dateFin);

    useEffect(() => {
        console.log('certificats[index]',certificats[index]);
        setCertificat(certificats[index]);
        setTitre(certificats[index]?.titre);
        if(certificats[index]?.dateFin)
            setDate(certificats[index]?.dateFin);
        //if(certificat?.dateFin)
        //    setDateFin(certificat?.dateFin);
    }, [certificats]);

    const annulerUpdateCertif = ()=>{
        const list=[...certificats];
        const temp=certificats[index];
        temp.isEdited=false;
        list.splice(index, 1,temp);
        setCertificats(list);
    };

    function isAuthorizedType(typeTraitement) {
        return authorizedTypes.includes(typeTraitement);
    }

    const handleInputChangeCertifs = () => {
        const tempCertif =certificat;
        tempCertif.isEdited=true;
        setCertificat(tempCertif);
        const list=[...certificats];
        list.splice(index, 1,tempCertif);
        setCertificats(list);
    };
    const supprimerUpdateCertif = ()=>{
        const list = [...certificats];
        list.splice(index, 1);
        setCertificats(list);
        setCheckUpdateValue(false);
    };

    const updateCertif  = () => {
        const tempCertif ={titre:titre,dateFin:date,isEdited:false};
        setCertificat(tempCertif);
        const list=[...certificats];
        list.splice(index, 1,tempCertif);
        setCertificats(list);
        setCheckUpdateValue(false);
    };

    return (
        <>
            {
                certificat?.isEdited==false ?
                    <div
                        style={{
                            display:'flex',
                            flexDirection:'row',
                            justifyContent: 'space-between',
                            alignSelf: 'stretch',
                            width:'100%'
                        }}
                    >
                        <div
                            className='experiencesStyle'
                            style={{width:'80%'}}
                        >
                            <p className='ecole'>{formatDateYYYY(certificat?.dateFin)}</p>
                            <div className='certifnamestyle'>
                                <p className='certifformationame'>{certificat?.titre}</p>
                            </div>
                        </div>
                        {(role !='client' && isAuthorizedType(typeTraitement)) &&
                            <div className='editIcon'>
                                <div className='editIcon1'>
                                    <IconButton
                                        onClick={()=>{handleInputChangeCertifs();}}
                                    >
                                        <ModeEditOutlinedIcon />
                                    </IconButton>
                                </div>
                                <div className='editIcon1'>
                                    <IconButton
                                        onClick={()=>{supprimerUpdateCertif();}}
                                    >
                                        <DeleteForeverIcon />
                                    </IconButton>
                                </div>
                            </div>
                        }
                    </div>
                    :
                    <div style={{display:'flex',flexDirection:'column',gap: '16px',alignSelf:'stretch'}}>
                        <div
                            className='techcompetencestyle'
                        >
                            <div style={{width:'50%'}}>
                                <p className='row1skillnametxt2'>{i18n.t('Formation ou certificat')}</p>
                                <TextFieldComponent
                                    style={{width:'100%',background:'white'}}
                                    value={titre}
                                    //name='titre'
                                    onChange={e => setTitre(e.target.value)}
                                    type='text'
                                    sx={{
                                        '& > :not(style)': {borderRadius: '8px'},
                                    }}
                                />
                            </div>
                            <div style={{width:'50%'}}>
                                <p className='row1skillnametxt2'>{i18n.t('Date')}</p>
                                <DatePickerComponent
                                    date={date}
                                    name='date'
                                    setDate={(newValue) => setDate(newValue)}
                                    width={'100%'}
                                    views={['year', 'month']}
                                />
                            </div>
                            {/*<div style={{width:'24%'}}>
                                <p className='row1skillnametxt2'>Date fin</p>
                                <DatePickerComponent
                                    value={dateFin}
                                    onChange={e => setDateFin(e)}
                                    width={'100%'}
                                    name='dateFin'
                                    views={['year', 'month']}
                                    error={isValidRangeDateCertif && !!messageRangeDateCertif}
                                    helperText={isValidRangeDateCertif ? messageRangeDateCertif : null}
                                />
                            </div>*/}
                        </div>
                        {(role !='client' && isAuthorizedType(typeTraitement)) &&
                            <div style={{display:'flex',flexDirection:'row',justifyContent: 'space-between',alignSelf:'stretch'}}>
                                <Button
                                    variant="text"
                                    startIcon={<DeleteForeverIcon />}
                                    //color="error"
                                    style={{...buttonStyles(),...{color:'#EC5B56'}}}
                                    //style={{height:'56px',
                                    //    fontFamily: 'Lato',
                                    //    fontStyle: 'normal',
                                    //    fontWeight: '600',
                                    //    fontSize: '20px',
                                    //    color:'#EC5B56'
                                    //}}
                                    onClick={()=>{
                                        supprimerUpdateCertif();
                                    }}
                                >
                                    {i18n.t('Supprimer')}
                                </Button>
                                <div style={{display:'flex',flexDirection:'row',gap: '16px'}} >
                                    <Button
                                        variant='text'
                                        style={{...buttonStyles()}}
                                        //style={{
                                        //    fontFamily: 'Lato',
                                        //    fontStyle: 'normal',
                                        //    fontWeight: '600',
                                        //    fontSize: '20px',
                                        //    height: '56px'
                                        //}}
                                        onClick={()=>{
                                            annulerUpdateCertif();
                                        }}
                                    >
                                        {i18n.t('Annuler')}
                                    </Button>
                                    <Button
                                        variant='contained'
                                        style={{...buttonStylesGreen()}}

                                        //disabled={isValidRangeDateCertif && !!messageRangeDateCertif}
                                        onClick={()=>{
                                            updateCertif();
                                        }}
                                    >
                                        {i18n.t('Valider')}
                                    </Button>
                                </div>
                            </div>
                        }
                    </div>
            }
        </>
    );

}
export default EditerCertificats;